import styled from 'styled-components'
import Flex from 'components/Flex'
import Button from 'components/Button/index'
import { COLORS } from 'theme'
import { Form as AntdForm } from 'antd'

export const InfoSection = styled(Flex)`
  gap: 5px;
  justify-content: space-between;
  align-items: center;
  border: 2px solid ${COLORS.PAGE_BORDER};
  border-radius: 4px;
  padding: 0.8rem 0.5rem;
  background-color: ${COLORS.PRIMARY_GREY_T_98};
  margin-bottom: 1rem;
`
export const SmallButtons = styled(Button.Default)`
  background: ${COLORS.WHITE};
  padding: 9px;
  border-radius: 50%;
  border: ${props => !props.border && 'none'};
  > div {
    margin-left: 0;
  }
`
export const SampleDocContainer = styled.div`
  line-height: 1.3rem;
`
export const BoldText = styled.div`
  font-weight: 700;
  font-size: 0.8rem;
`
export const LightText = styled.div`
  color: ${COLORS.GREY_T_60};
  font-size: 0.8rem;
  font-weight: 600;
`
export const ContainerDiv = styled.div`
  margin-bottom: 0;
`
export const FooterFlex = styled(Flex)`
  gap: 20px;
`
export const Form = styled(AntdForm)`
  row-gap: 20px;
  display: flex;
  flex-direction: column;
`
export const ErrorMessage = styled.div`
  font-size: 14px;
  color: ${COLORS.ERROR};
`
